import { useEffect, useState } from "react";
import { DataTable } from "@/components/table/components/data-table";
import { columns, columns2 } from "@/components/table/components/columns";
import { Link } from "react-router-dom";
import { History } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import AppLayout from "@/components/AppLayout";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { db } from '@/services/Database';
import { showErrorToast } from "@/components/toast/toast";

export default function OfflineProjectsPage() {
  const [projects, setProjects] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadProjects = async () => {
      try {
        setIsLoading(true);
        const allProjects = await db.getAllProjects();
        setProjects(allProjects || []);
      } catch (err) {
        console.error('Error loading projects:', err);
        showErrorToast('Failed to load projects');
        setProjects([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadProjects();
  }, []);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  return (
   <AppLayout>  

<div className="pt-5 relative h-[calc(100vh-80px)] overflow-y-auto">
      <div className="bg-blue w-16 fixed h-svh z-10 top-0 flex flex-col pt-[150px]">
        <Link
          to="/"
          className="bg-white p-3 rounded-md rounded-tr-none rounded-br-none mx-1"
        >
          <History size={30} className="text-states-warning" />
        </Link>
      </div>
      {/* <div className="w-full pl-[100px] pr-[50px] pt-[50px]">
        <Accordion type="single" collapsible defaultValue="item-1">
          <AccordionItem value="item-1">
            <AccordionTrigger
              disabled
              iconPosition="right"
              className="border data-[state=open]:border-b-0 p-2 flex-center justify-start gap-2 text-left border-border-style-1 rounded-md data-[state=open]:rounded-b-none text-blue font-semibold"
            >
              Distribution Analytics Project List (Offline)
            </AccordionTrigger>
            <AccordionContent className="border">
              <DataTable data={projects} columns={columns} isOffline={true} />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div> */}
      <div className="w-full pl-[100px] pr-[50px] pt-[20px]">
        <Accordion type="single" collapsible>
          <AccordionItem value="item-1">
            <AccordionTrigger
              iconPosition="right"
              className="border data-[state=open]:border-b-0 p-2 flex-center justify-start gap-2 text-left border-border-style-1 rounded-md data-[state=open]:rounded-b-none text-blue font-semibold"
            >
              Physical Test Data Collection Project List (Offline)
            </AccordionTrigger>
            <AccordionContent className="border">
              <DataTable data={projects} columns={columns2} isOffline={true} />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
   </AppLayout>
  );
}
